import {connect} from "react-redux";
import {otpTypeRegisterReset, sendOtpType} from "./authWithOtp/redux2";
import React from "react";
import PropTypes from "prop-types";
import Layout from './Layout';
import {replace} from "react-router-redux";
import LoadingBlocking from "../components/loading/LoadingBlocking";
import reduxRouteChanged from "../services/reduxRouteChanged";
import {datadogRum} from "@datadog/browser-rum";
import {OtpTypeForm} from "./OtpTypeForm";
import {registerOtpUrl} from "../utils/url/registerOtpUrl";
import loginUrl from "../utils/url/loginUrl";
import {OtpTooManyAttempts} from "./OtpTooManyAttempts";
import {OTP_ACTIVITY_BLOCKED_UNTIL} from "./authWithOtp/constants2";
import registerUrl from "../utils/url/registerUrl";
import mixpanelService from '../services/mixpanel';

@connect(
  state => {
    return {
      firstName: state.authRoot.register.firstName,
      phoneLast4digits: state.authRoot.register.phoneLast4digits,
      signUpRequestToken: state.authRoot.register.signUpRequestToken,
      isSuccess: state.authRoot.register.isOtpTypeSuccess,
      isLoading: state.authRoot.register.isLoadingOtpType,
      isFail: state.authRoot.register.isOtpTypeFail,
      otpTypeError: state.authRoot.register.otpTypeError,
    };
  },
  dispatch => ({
    redirect: (path) => dispatch(replace(path)),
    sendOtpType: ({otpType, token}) => dispatch(sendOtpType({otpType, token})),
  })
)
class OtpTypeRegisterController extends React.Component {

  static propTypes = {
    firstName: PropTypes.string,
    phoneLast4digits: PropTypes.string,
    signUpRequestToken: PropTypes.string,
    sendOtpType: PropTypes.func.isRequired,
    redirect: PropTypes.func.isRequired,
    isSuccess: PropTypes.bool,
    isLoading: PropTypes.bool,
    isFail: PropTypes.bool,
    otpTypeError: PropTypes.object,
  };

  constructor(props) {
    super(props);

    this.state = {
      isBlocked: false,
      blockedUntil: undefined,
    };
  }

  componentDidMount() {
    if (!this.props.signUpRequestToken) {
      this.props.redirect(loginUrl());
    }
  }

  componentDidUpdate(prevProps) {
    const { isSuccess, isFail, redirect, otpTypeError } = this.props;
    if (!prevProps.isSuccess && isSuccess) {
      datadogRum.addUserAction('Sign up OTP type send success', {});
      mixpanelService.track('OTP sign up', {step: 'otp type send success'});
      redirect(registerOtpUrl());
    }
    if (!prevProps.isFail && isFail) {
      datadogRum.addUserAction('Sign up OTP type send failed', {otpTypeError});
      mixpanelService.track('OTP sign up', {step: 'otp type send failed'});
      if (otpTypeError.code === OTP_ACTIVITY_BLOCKED_UNTIL) {
        this.setState(state => {
          return {
            ...state,
            isBlocked: true,
            blockedUntil: +otpTypeError.message,
          };
        });
      }
    }
  }

  otpTypeSelected(otpType) {
    this.props.sendOtpType({otpType, token: this.props.signUpRequestToken});
  }

  navigateToRegister() {
    this.props.redirect(registerUrl());
  }

  render() {
    return (
      <Layout>
        {this.props.isLoading && <LoadingBlocking/>}

        {!this.state.isBlocked && <OtpTypeForm onSubmit={(otpType) => this.otpTypeSelected(otpType)}
                                               firstName={this.props.firstName}
                                               phone={this.props.phoneLast4digits ? `(***) ***-${this.props.phoneLast4digits}` : ''}
                                               isFail={this.props.isFail}/>}

        {this.state.isBlocked && <OtpTooManyAttempts timeLeft={this.state.blockedUntil}
                                                     onTimerEnd={() => this.navigateToRegister()}/>}
      </Layout>
    );
  }
}


function initStore(dispatch) {
  dispatch(otpTypeRegisterReset());
}

export default reduxRouteChanged(initStore,  OtpTypeRegisterController);



// WEBPACK FOOTER //
// ./src/auth/OtpTypeRegisterController.js